'use client'

import styles from "./NavAcessibilidade.module.css";
import React, { useEffect } from "react";
import useKeyboardNavigation from "../../hooks/useKeyboardNavigation";
import useContraste from "../../hooks/useContraste";
import useFontSize from "../../hooks/useFontSize";
import { useRouter } from 'next/navigation';
import Image from '@/components/CspImage/CspImage';

const NavAcessibilidade: React.FC = () => {
  useKeyboardNavigation();
  const navigate = useRouter();
  const { isContraste, toggleContraste } = useContraste();
  const { aumentarFonte, diminuirFonte } = useFontSize();

  const accessibilityLinks = [
    { id: "conteudo", label: "o conteúdo", key: "1", labelb: "o conteúdo", keyb: "1" },
    { id: "menu", label: "o menu", key: "2", labelb: "o menu", keyb: "2" },
    { id: "footer", label: "o rodapé", key: "3" },
    { id: "/Acessibilidade", label: "a página de acessibilidade", key: "4", labelb: "a página de acessibilidade", keyb: "4" },
  ];


  useEffect(() => {
    if (localStorage.getItem('contraste') === 'true') {
      document.documentElement.classList.add('contraste');
    }
  }, []);

  return (
    <section className={styles.acessibilidadeTopo}>
      <div className={styles.uiContainer}>
        <div className={styles.containerFlex}>
          <nav>
            <ul className={styles.listMenuAcessibilidade}>
              {accessibilityLinks.map(({ id, label, key, labelb, keyb }) => (
                <li key={key}>
                  <button
                    aria-label={`Ir para ${label} ${key}, Digite Alt + ${keyb} para ir para ${labelb}`}
                    className={styles.linkAcessibilidade}
                    tab-index="0"
                    onClick={() =>
                      id.startsWith("/") ? navigate.push(id) : document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })
                    }
                  >
                    <p className={styles.listMenuAcessibilidadeItemText} tab-index="0">
                      Ir para {label} <span className={styles.acessibilidadeNum}>{key}</span>
                    </p>
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          <nav>
            <ul className={styles.listMenuAcessibilidade}>
              <li className={styles.lineContrast}>
                <button className={styles.linkAcessibilidade}  aria-label="Autocontraste - Aplicar contraste" type="button" onClick={toggleContraste} aria-pressed={isContraste}>
                  <Image
                    src="/images/contrasteicon.png"
                    alt="Ícone Botão Contraste"
                    width={11}
                    height={10}
                    priority={true}
                    aria-hidden="true"
                  /> 
                  <span>AUTOCONTRASTE</span>
                </button>
              </li>
              <li>
                <button
                  className={styles.linkAcessibilidadeSize}
                  onClick={aumentarFonte}
                  aria-label="A + Aumentar fonte"
                  tabIndex={0}
                  type="button"
                >
                  A +
                </button>
              </li>
              <li>
                <button
                  className={styles.linkAcessibilidadeSize}
                  onClick={diminuirFonte}
                  aria-label="A - Diminuir fonte"
                  tabIndex={0}
                >
                  A -
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </section>
  );
};

export default NavAcessibilidade;